import React from "react";
import { Container, Row, Col } from "react-bootstrap";
import GymAndDates from "../global-filters/GymAndDates";
import "../../styles/common-styles.css";
import "../../styles/wtf-payouts/wtf-payouts.css";
import "../../styles/wtf-payouts/settlement-systems.css";
import TabsPayouts from "./payout-tabs/TabsPayouts";
// import { ToastContainer } from "react-toastify";
import HelmetWrapper from "../../HelmetWrapper";

function WTFPayouts() {
  return (
    <HelmetWrapper title="WTF: Payouts">
      <Container fluid className="container purePayouts">
        {/* <ToastContainer /> */}

        <Row>
          <Col>
            <GymAndDates />
          </Col>
        </Row>
        <Row>
          <Col>
            <h1 className="wtfPayoutsHeading" style={{ marginBottom: "1rem" }}>
              WTF Payouts
            </h1>
          </Col>
        </Row>
        <Row>
          <Col>
            <TabsPayouts />
          </Col>
        </Row>
      </Container>
    </HelmetWrapper>
  );
}

export default WTFPayouts;
